import { createContext } from 'react';
/**
 * React context for managing UI-related state across the application.
 * Provides access to survey visibility, error component state, and map visibility.
 * @public
 */
export const ChatUIContext = createContext({});